import { FC, HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import cn from 'classnames';

import { EGaCategories, EGaEvents } from 'shared/typings';
import { sendGaEvent } from 'shared/utils';

import styles from './Logo.module.scss';

interface ILogoProps extends HTMLAttributes<HTMLDivElement> {
	image: string;
	width?: number;
	height?: number;
	type?: 'header' | 'footer';
}

export const Logo: FC<ILogoProps> = ({ className, image, type = 'header', width = 42, height = 20, ...props }) => {
	return (
		<div {...props} className={cn(className, styles.logo)}>
			<Link
				to="/"
				onClick={() =>
					sendGaEvent(EGaEvents.CLICK_LOGO, {
						event_option1: EGaCategories.ACCOUNT,
						event_option2: type,
					})
				}>
				<img src={image} alt="CLick&Pay" width={width} height={height} />
			</Link>
		</div>
	);
};
